<template>
    <div class="modal is-active">
    <div class="modal-background" @click="emitClose"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Produkte anfragen</p>
        <button class="delete" aria-label="close" @click="emitClose"></button>
      </header>
      <section class="modal-card-body " :style="resize">
        <div class="formular" v-if="!successfullySubmitted">
          <p>Vielen Dank für Ihr Interesse an unseren Produkten. Nachfolgend
          können Sie Ihre gewünschten Konfigurationen anfragen.</p>
          <table class="table is-fullwidth is-narrow">
            <thead>
              <th>Bezeichnung</th>
              <th width="150px">Menge</th>
              <th></th>
            </thead>
            <tbody>
              <tr v-for="(lineItem, index) in cart" :key="index">
                <td>{{ lineItem.name }}</td>
                <td>
                  <QuantitySelect
                    size="is-small"
                    :variation-id="lineItem.id"
                    :pre-selected-quantity="lineItem.quantity"
                    @setQuantity="setQuantity"
                  />
                  </td>
                <td><div class="delete" @click="removeFromCart(lineItem)" /></td>
              </tr>
            </tbody>
          </table>
          <p>Wir benötigen mindestens ihre E-Mailadresse um mit Ihnen Kontakt aufnehmen zu können. Gern können Sie uns untenstehend auch weitere Angaben übermitteln.</p>
          <div class="gap-1" />
          <div class="columns is-gapless" align="left">
            <div class="column is-12">

              <div class="field">
                <label class="label" for="formEmail">E-Mail <span class="has-text-danger">*</span></label>
                <input type="email" class="input" id="formEmail" v-model="request.customer.email" />
              </div>

              <div class="field">
                <label class="label" for="formCompanyName">Firma</label>
                <input type="text" class="input" id="formCompanyName" v-model="request.customer.company_name" />
              </div>

              <div class="columns">
                <div class="column">
                  <div class="field">
                    <label class="label" for="formFirstName">Vorname <span class="has-text-danger">*</span></label>
                    <input type="text" class="input" id="formFirstName" v-model="request.customer.firstname" />
                  </div>
                </div>
                <div class="column">
                  <div class="field">
                    <label class="label" for="formLastName">Nachname <span class="has-text-danger">*</span></label>
                    <input type="text" class="input" id="formLastName" v-model="request.customer.lastname" />
                  </div>
                </div>
              </div>
              <div class="field">
                <label class="label" for="formStreet">Straße & Nr. <span class="has-text-danger">*</span></label>
                <input type="text" class="input" id="formStreet" v-model="request.customer.street" />
              </div>
              <div class="columns">
                <div class="column">
                  <div class="field">
                    <label class="label" for="formZip">PLZ <span class="has-text-danger">*</span></label>
                    <input type="text" class="input" id="formZip" v-model="request.customer.zip" />
                  </div>
                </div>
                <div class="column">
                  <div class="field">
                    <label class="label" for="formCity">Ort <span class="has-text-danger">*</span></label>
                    <input type="text" class="input" id="formCity" v-model="request.customer.city" />
                  </div>
                </div>
              </div>
              <div class="field">
                <label class="label" for="formPhone">Telefon <span class="has-text-danger">*</span></label>
                <input type="text" class="input" id="formPhone" v-model="request.customer.phone" />
              </div>
              <div class="field">
                <label class="label" for="formNumber">Kundennummer (falls vorhanden)</label>
                <input type="text" class="input" id="formNumber" v-model="request.customer.internal_identifier" />
              </div>
            </div>
          </div>
          <div class="field" align="left">
            <label class="label" for="formComments">Anmerkungen</label>
            <textarea class="textarea" id="formComments" rows="6" v-model="request.comments"/>
          </div>
          <div class="field">
            <label class="checkbox">
              <input type="checkbox" v-model="request.termsAccepted">
              Mit dem Absenden des Kontaktformulars erklären Sie sich damit einverstanden, dass Ihre Daten zur Bearbeitung Ihres Anliegens verwendet werden (Weitere Informationen und Widerrufshinweise finden Sie in der<a href="https://www.guntramend.de/datenschutz/" target="_blank">Datenschutzerklärung</a>) <span class="has-text-danger">*</span>
            </label>
          </div>
          <button :disabled="formIncomplete" v-if="!successfullySubmitted" :class="['button is-primary is-cornered', { 'is-loading' : loading }]" @click="sendRequest()">
            <span>Produkte bei Guntram End GmbH anfragen</span>
          </button>
        </div>
        <div class="has-text-danger" v-if="error">Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.</div>
        <div class="is-size-5 has-text-darkgreen" v-if="successfullySubmitted">
          <div><IconSuccess class="success-icon"/></div>
          <p class="thanks-message">Vielen Dank für Ihre Anfrage. Wir haben Ihnen eine Bestätigung an die angegebene E-Mail Adresse geschickt und Sie hören von uns in Kürze.</p>
          <div class="checkbox-restart is-centered" align="center">
            <label class="switch">
              <input type="checkbox">
              <span class="slider round" @click="toggle"></span>
            </label>
            <span class="has-text-danger" v-if="isActive">Der Konfigurator wird neu gestartet !</span>
            <span v-if="!isActive">Konfigurator neu starten ?</span>
          </div>
          <button class="button is-primary is-cornered" @click="emitClose">Schließen</button>
        </div>
        <div class="has-text-danger" v-if="formIncomplete">
          <div v-if="request.customer.email.length === 0">Bitte geben Sie eine E-Mail Adresse an</div>
          <div v-if="!request.customer.termsAccepted">Bitte akzeptieren Sie unsere Datenschutzerklärung</div>
          <div v-if="request.customer.firstname.length === 0">Bitte geben Sie Ihren Vornamen ein</div>
          <div v-if="request.customer.lastname.length === 0">Bitte geben Sie Ihren Nachnamen ein</div>
          <div v-if="request.customer.street.length === 0">Bitte geben Sie Ihren Straße & Nr. ein</div>
          <div v-if="request.customer.zip.length === 0">Bitte geben Sie Ihre PLZ ein</div>
          <div v-if="request.customer.city.length === 0">Bitte geben Sie Ihre Ort ein</div>
          <div v-if="request.customer.phone.length === 0">Bitte geben Sie Ihre Telefonnummer ein</div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import client from '@/client'
import QuantitySelect from '@/components/QuantitySelect'
import IconSuccess from '@/components/Icons/IconSuccess'


export default {
  components: { QuantitySelect, IconSuccess },
  data () {
    return {
      isActive: false,
      request: {
        customer: {
          email: '',
          company_name: '',
          firstname: '',
          lastname: '',
          street: '',
          zip: '',
          city: '',
          phone: '',
          internal_identifier: '',
        },
        comments: null,
        termsAccepted: false,
      },
      loading: false,
      successfullySubmitted: false,
      error: false
    }
  },
  computed: {
    cart () {
      return this.$store.state.cart
    },
    currentProduct: {
      set (val) {
          this.$store.commit('setCurrentProduct', val)
      },
      get () {
          return this.$store.state.currentProduct
      }
    },
    currentStep: {
      set (val) {
          this.$store.commit('setCurrentStep', val)
      },
      get () {
          return this.$store.state.currentStep
      }
    },
    formIncomplete () {
      return this.request.customer.email.length === 0 || !this.request.termsAccepted || this.request.customer.firstname.length === 0 || this.request.customer.lastname.length === 0 || this.request.customer.street.length === 0 || this.request.customer.zip.length === 0 || this.request.customer.city.length === 0 || this.request.customer.phone.length === 0
    },
    totalPrice () {
      return this.$store.getters.totalPrice
    },
    currentCustomer () {
      return this.$store.state.currentCustomer
    },
    resize () {
      if(this.successfullySubmitted) {
        return {'--height' : 40 + 'vh' }
      } else {
        return {'--height' : 80 + 'vh' }
      }
    }
  },
  methods: {
    async sendRequest () {
      try {
        // set configuration

        // sanitize configuration
        let sanitizedConfiguration = []
        this.cart.forEach(lineItem => {
          sanitizedConfiguration.push({
            name: lineItem.name,
            sku: lineItem.sku,
            quantity: lineItem.quantity
          })
        })

        // ToDo: Document on API how to expect configuration data
        const configuration = {
          product: this.currentProduct,
          comments: this.request.comments,
          total_price: this.totalPrice,
          configurated_options: sanitizedConfiguration
        }

        this.request['name'] = this.currentProduct.name
        this.request['data'] = configuration
        this.request['send_offer'] = true
        this.request['send_mail_to_customer'] = true
        this.request['send_to_emails'] = "anfragen@guntramend.de"

        const res = await client.post('/public/configurations', this.request)
        if (res) {
          this.successfullySubmitted = true
        }
      } catch (error) {
        console.log(error)
      }
    },
    emitClose () {
      if(this.isActive) {
        this.currentProduct = null
        this.currentStep = 'Unterkonstruktion'
        this.$emit('close')
      } else {
        this.$emit('close')
      }
    },
    removeFromCart (lineItem) {
      this.$store.commit('removeFromCart', lineItem)
      if (this.cart.length === 0) {
        this.emitClose()
      }
    },
    setQuantity (val) {
      this.$store.commit('updateQuantityInCart', val)
    },
    toggle() {
      this.isActive = !this.isActive;
    },
  }
}
</script>

<style lang="sass" scoped>
@import "@/assets/sass/main.sass"

.modal-card-body
  height:  var(--height)
  transition: .5s
  .preview-wrap
    height: 300px
  .input, .textarea
    border-color: grey

.success-icon
  color: $primary
  width: 50px
  height: 50px
  margin: 30px 0 30px 0

.thanks-message
  margin: 0 0 30px 0

.switch
  position: relative
  display: inline-block
  width: 40px
  height: 24px
  margin-right: 10px

.checkbox-restart
  display: flex
  align-items: center
  justify-content: center!important
  margin-bottom: 30px

.switch input
  opacity: 0
  width: 0
  height: 0

.slider
  position: absolute
  cursor: pointer
  top: 0
  left: 0
  right: 0
  bottom: 0
  background-color: #ccc
  -webkit-transition: .4s
  transition: .4s

.slider:before 
  position: absolute
  content: ""
  height: 16px
  width: 16px
  left: 4px
  bottom: 4px
  background-color: white
  -webkit-transition: .4s
  transition: .4s

.slider.round 
  border-radius: 34px

.slider.round:before
  border-radius: 50%

input:checked + .slider 
  background-color: $primary

input:focus + .slider 
  box-shadow: 0 0 1px $primary

input:checked + .slider:before 
  -webkit-transform: translateX(16px)
  -ms-transform: translateX(16px)
  transform: translateX(16px)

</style>
